import React from 'react';
import classNames from 'classnames';
import { MessagePropertiesContext } from '../../contexts/messageProperties';

interface FinanceFixedDepositProps {
  setIsSelected: (isSelected: boolean) => void;
  fixedDepositAmount: null | number;
  isSelected: boolean;
  disabled: boolean;
}

function FinanceFixedDeposit({
  isSelected,
  setIsSelected,
  fixedDepositAmount,
  disabled
}: FinanceFixedDepositProps): React.ReactElement {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);
  React.useEffect(() => {
    if (setIsSelected && fixedDepositAmount === null) {
      setIsSelected(false);
    }
  }, [fixedDepositAmount, setIsSelected]);

  return (
    <div
      className={classNames('finance-fixed-deposit', {
        'finance-fixed-deposit--disabled': disabled,
        'finance-fixed-deposit--isSelected': isSelected,
        hide: fixedDepositAmount === null
      })}
    >
      <label className="checkbox__label finance-fixed-deposit__checkbox-label" htmlFor="finance-fixed-deposit-tick">
        <input
          id="finance-fixed-deposit-tick"
          type="checkbox"
          className="checkbox__field finance-fixed-deposit__checkbox-input"
          onChange={(e): void => setIsSelected(e.currentTarget.checked)}
          checked={isSelected}
          disabled={disabled}
        />
        <span className="checkbox__checkmark finance-fixed-deposit__checkbox-span" />
      </label>
      <div>
        <p
          className="finance-fixed-deposit__label-text"
          dangerouslySetInnerHTML={{
            __html: formattedMessage({
              id: 'checkout.components.finance.fixedDeposit.label',
              values: { 0: `${fixedDepositAmount}` },
              fallback: `Pay a low deposit of £${fixedDepositAmount}`
            })
          }}
        />
        <p className="finance-fixed-deposit__heading">
          {formattedMessage({
            id: 'checkout.components.finance.fixedDeposit.heading',
            fallback: 'Available for a limited period only'
          })}
        </p>
      </div>
    </div>
  );
}

export default FinanceFixedDeposit;
